import { createFileRoute } from '@tanstack/react-router'
import { PageShell } from '@/features/public-site/page-shell'
import { SimpleHero, HeroBadges, PricingCta, Panel } from '@/features/public-site/sections'

const apiCards = [
  { title: '创建片段', description: 'POST /v1/clips — 提交源视频，获取 AI 选取的片段' },
  { title: '添加字幕', description: 'POST /v1/captions — 添加 100+ 语言的动效字幕' },
  { title: '配音与翻译', description: 'POST /v1/dub — 多语言翻译和配音' },
  { title: '导出视频', description: 'POST /v1/exports — 以多种格式和分辨率导出' },
  { title: 'Webhooks', description: '视频就绪时实时回调通知' },
  { title: 'SDK', description: 'Node.js 和 Python SDK，无缝集成' },
]

export const Route = createFileRoute('/api')({
  component: ApiPage,
})

function ApiPage() {
  return (
    <PageShell>
      <SimpleHero
        eyebrow="开发者 API"
        title="剪辑、字幕与"
        highlighted="配音"
        description="用简单的 REST API 把视频自动化接入你的产品。支持异步任务、Webhooks，以及 Node.js 和 Python SDK。"
        buttonLabel="获取 API Key"
        secondaryLabel="阅读文档"
        secondaryHref="/docs"
      />

      <HeroBadges
        items={['REST API', '异步任务', 'Webhooks', 'Node.js SDK', 'Python SDK']}
      />

      {/* Split section */}
      <section className="mx-auto mt-16 grid max-w-4xl gap-8 px-4 sm:px-6 lg:grid-cols-2">
        <Panel>
          <h2 className="text-xl font-bold text-foreground">完整的视频工作流 API</h2>
          <p className="mt-3 text-sm text-muted-foreground">
            端到端自动化视频生产所需的一切能力。
          </p>
          <ul className="mt-6 space-y-4">
            {apiCards.map((card) => (
              <li key={card.title} className="border-b border-border pb-4">
                <div className="text-sm font-semibold text-foreground">{card.title}</div>
                <div className="mt-1 text-xs text-muted-foreground">{card.description}</div>
              </li>
            ))}
          </ul>
        </Panel>

        <Panel>
          <h2 className="text-sm font-semibold text-muted-foreground">请求示例</h2>
          <pre className="mt-4 overflow-x-auto rounded-lg bg-black/40 p-4 text-xs text-foreground">
{`POST /v1/clips
Content-Type: application/json

{
  "source_url": "https://youtube.com/watch?v=...",
  "topic": "产品发布",
  "aspect_ratio": "9:16",
  "captions": {
    "style": "Beasty",
    "language": "zh"
  }
}`}
          </pre>
          <h3 className="mt-6 text-sm font-semibold text-foreground">
            团队为什么选择它
          </h3>
          <p className="mt-2 text-xs text-muted-foreground">
            无需扩大团队规模即可扩展视频生产。自动化重复的编辑任务，把精力放在创意策略上。
          </p>
        </Panel>
      </section>

      <PricingCta />
    </PageShell>
  )
}
